import type { MsSpec } from './schema';
import { msFromForm } from './spec';

/**
 * 将 SKU preset 归一化为可 parse 的 MsSpec。
 * 仅支持当前扁平表单 preset 与完整 MsSpec；不做旧版 targetServices / tokenTotal / _show* 迁移。
 */
export function normalizeMsPresetToSpec(data: unknown): MsSpec {
  const raw = data && typeof data === 'object' ? (data as Record<string, unknown>) : {};

  if (raw.resourceLimits && raw.rateLimits && raw.llmgwStrategyRef) {
    return raw as MsSpec;
  }

  return msFromForm(raw, {});
}

/** versioned preset 各版本入口（内容同当前格式） */
export const msMigrations: Record<number, (data: unknown) => MsSpec> = {
  1: normalizeMsPresetToSpec,
  2: normalizeMsPresetToSpec,
};
